import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { Filters } from "./styles";
import { COLORS, Typo } from "../../../layout/theme";
import { get_agents_by_client_id } from "../../../../api/endpoints/agents";
import Main from "../../../layout/main/Main";
import DataTable from "../../../common/data-table/DataTable";

// Bit flags iguales a AgentCapabilities en API
// 001
const CAP_SELLER = 1;
// 010
const CAP_ASSISTANT = 2;
// 100
const CAP_MULTI_CLIENT = 4;

const getAgentCapabilities = (agent) => {
	let caps = 0;

	if (agent.isSeller) caps |= CAP_SELLER;
	if (agent.isAssistant) caps |= CAP_ASSISTANT;
	if (agent.isMultiClient) caps |= CAP_MULTI_CLIENT;

	return caps;
};

const getAgentTypeLabel = (agent) => {
	const caps = getAgentCapabilities(agent);

	switch (caps) {
		case 0:
			return "Agente por defecto";

		case CAP_SELLER: // Seller
			return "Vendedor laboratorio";

		case CAP_ASSISTANT: // Assistant
			return "Asistente";

		case CAP_MULTI_CLIENT: // MultiClient
			return "Agente multicliente";

		case CAP_SELLER | CAP_ASSISTANT: // Seller + Assistant
			return "Vendedor + Asistente";

		case CAP_SELLER | CAP_MULTI_CLIENT: // Seller + MultiClient
			// En backend: MultiClientSellerAgentToolStrategy
			return "Vendedor multicliente";

		case CAP_ASSISTANT | CAP_MULTI_CLIENT: // Assistant + MultiClient
			return "Asistente multicliente";

		case CAP_SELLER | CAP_ASSISTANT | CAP_MULTI_CLIENT:
			return "Vendedor + Asistente multicliente";

		default:
			return "Tipo desconocido";
	}
};

export default function LaboratoryAgentsList({ clientId }) {
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [data, setData] = useState(null);
	const [state, setState] = useState("ACTIVE");
	const [key, setKey] = useState("null");

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Agente</div>,
			dataIndex: "phoneNumber",
			width: 300,
			render: (value, record) => (
				<Link
					to={`/admin/laboratoryAgentProducts/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="primary" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</Link>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Tipo</div>,
			dataIndex: "agentType",
			width: 300,
			render: (value, record) => (
				<Link
					to={`/admin/laboratoryAgentProducts/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="secondary" fontWeight={600} fontSize={14}>
						{getAgentTypeLabel(record)}
					</Typo>
				</Link>
			),
		},
	];

	const fetch_data_agent_clients = async (page, search) => {
		const res = await get_agents_by_client_id(search, clientId, state, page);
		setData(res);
	};

	useEffect(() => {
		fetch_data_agent_clients(1, "");
	}, [state]);

	return (
		<Main>
			<Main.Breadcrumb>
				<Main.BreadcrumbItem>
					{uri ? (
						<Link to={"/" + uri}>Configuración General</Link>
					) : (
						<Link to="/">Home</Link>
					)}
				</Main.BreadcrumbItem>
				<Main.BreadcrumbSeparator />
				<Main.ActiveBreadcrumbItem>
					Listado de clientes
				</Main.ActiveBreadcrumbItem>
			</Main.Breadcrumb>

			<Main.Body>
				<Filters></Filters>
				<DataTable
					data={data}
					fetch={fetch_data_agent_clients}
					columns={columns}
				/>
			</Main.Body>
		</Main>
	);
}
